module.exports = __webpack_public_path__ + "static/leo-8ccc86bc1ac9de6f23a230e9f2d60efb.png";